import React from "react";

const SuccessIcon: React.FC = () => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      dangerouslySetInnerHTML={{
        __html: `<style>#circle{transform-origin:center;animation:circle .8s ease .2s backwards}#tick{transform-origin:center;animation:tick 1s ease .8s backwards}@keyframes circle{0%{transform:scale(0)}50%{transform:scale(1.2)}100%{transform:scale(1)}}@keyframes tick{0%{stroke-dashoffset:100px}100%{stroke-dashoffset:0}}</style><g id="success"><path id="circle" d="M24 4C12.95 4 4 12.95 4 24C4 35.04 12.95 44 24 44C35.04 44 44 35.04 44 24C44 12.95 35.04 4 24 4Z" fill="#A5BB48"/><polyline id="tick" style="fill:none;stroke:#fff;stroke-width:4;stroke-dasharray:100,100;stroke-dashoffset:200" points="11.4,22.6 20,31.1 36.6,14.6"/></g>`,
      }}
    />
  );
};

export default SuccessIcon;
